import { TriangleAlert as Warning24Regular, LogOut as SignOut24Regular } from "lucide-react";
import { useMsal } from "@azure/msal-react";
import { SkyButton, SkyCard, SkyBody1, SkyTitle2 } from "@skypointcloud/skypoint-ui";

export function NoAccessScreen() {
  const { instance } = useMsal();

  const handleSignOut = () => {
    instance.logoutRedirect();
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-surface-subtle">
      <SkyCard className="max-w-[440px] w-full flex flex-col items-center gap-4 text-center px-8 py-10">
        <Warning24Regular
          className="text-yellow-500 w-[48px] h-[48px]"
          fontSize={48}
        />
        <SkyTitle2 className="mt-2">Oops... you don&apos;t have access</SkyTitle2>
        <SkyBody1 className="text-fg-2">Please contact your admin to get access.</SkyBody1>
        <div className="mt-2 flex flex-col items-center gap-4 w-full">
          <SkyButton
            appearance="primary"
            icon={SignOut24Regular}
            onClick={handleSignOut}
          >
            Sign Out
          </SkyButton>
          <a
            href="mailto:support@skypoint.ai"
            className="no-underline hover:underline text-fg-2"
            style={{ fontSize: "12px" }}
          >
            Need help? support@skypoint.ai
          </a>
        </div>
      </SkyCard>
    </div>
  );
}

export default NoAccessScreen;
